import * as yup from "yup";

export const updateWaterDischargeCombustionValidation = yup.object({
  facility: yup.string().required("Facility is required"),
  month: yup.string().required("Month is required"),
  year: yup.string().required("Year is required"),
  destination: yup.string().required("Destination is required"),
  stressType: yup.string().required("Stress Type is required"),
  destinationType: yup.string().required("Destination Type is required"),
  treatmentRequired: yup.boolean().required("Treatment Required is required"),
  treatmentLevel: yup.string().when("treatmentRequired", {
    is: true, // Validate when treatmentRequired is `true` (boolean)
    then: yup.string().required("Treatment Level is required"),
    otherwise: yup.string().nullable(), // Allow null/undefined if not required
  }),
  fuelUnit: yup.string().required("Unit is required"),
  amountOfFuel: yup
    .number()
    .typeError("Amount of water must be a valid number")
    .required("Amount of water is required")
    .strict(true),
});
